"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('flatted/cjs'),
    parse = _require.parse,
    stringify = _require.stringify;

var BaseService = /*#__PURE__*/function () {
  function BaseService(_ref) {
    var _this = this;

    var configPath = _ref.configPath;
    (0, _classCallCheck2["default"])(this, BaseService);
    (0, _defineProperty2["default"])(this, "config", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var config;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.core.api.config.find(_this._configPath);

            case 2:
              config = _context.sent;
              return _context.abrupt("return", config);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])(this, "rawRequest", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(options) {
        var res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.core.requestAdapter.request(options);

              case 2:
                res = _context2.sent;
                return _context2.abrupt("return", res);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "authRequest", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref4) {
        var _ref4$tokenType, tokenType, _ref4$headers, headers, options, tokens, h;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref4$tokenType = _ref4.tokenType, tokenType = _ref4$tokenType === void 0 ? 'id' : _ref4$tokenType, _ref4$headers = _ref4.headers, headers = _ref4$headers === void 0 ? {} : _ref4$headers, options = (0, _objectWithoutProperties2["default"])(_ref4, ["tokenType", "headers"]);
                tokens = _this.core.api.tokens;
                h = _objectSpread({
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                }, headers);

                if (_this._appVersion) {
                  h['app-version'] = _this._appVersion;
                }

                if (_this._appFeatures) {
                  h['app-features'] = _this._appFeatures.join(',');
                }

                if (!(tokenType !== 'none')) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 8;
                return tokens.freshTokens();

              case 8:
                h.Authorization = "Bearer ".concat(tokens[tokenType]);
                if (process.env.DEBUG) console.log({
                  options: options,
                  token: h.Authorization
                });

              case 10:
                _context3.next = 12;
                return _this.request(_objectSpread({
                  headers: h
                }, options));

              case 12:
                return _context3.abrupt("return", _context3.sent);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "requestResource", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(methodName) {
        var opts,
            _opts$params,
            params,
            queryParams,
            options,
            config,
            urlTemplateString,
            template,
            url,
            _args4 = arguments;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                opts = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                _opts$params = opts.params, params = _opts$params === void 0 ? {} : _opts$params, queryParams = opts.queryParams, options = (0, _objectWithoutProperties2["default"])(opts, ["params", "queryParams"]);

                if (queryParams) {
                  options.params = queryParams;
                }

                _context4.next = 5;
                return _this.config();

              case 5:
                config = _context4.sent;
                urlTemplateString = methodName ? config.resources[methodName] : config.resource;
                template = _lodash["default"].template(urlTemplateString, {
                  interpolate: URL_INTERPOLATION_RULES
                });
                url = template(params); // TODO implement custom headers here from config

                _context4.next = 11;
                return _this.authRequest(_objectSpread({
                  url: url
                }, options));

              case 11:
                return _context4.abrupt("return", _context4.sent);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    this._configPath = configPath;
    this._appVersion = null;
    this._appFeatures = null;
  }

  (0, _createClass2["default"])(BaseService, [{
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(options) {
        var _yield$this$rawReques, data;

        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.rawRequest(options);

              case 2:
                _yield$this$rawReques = _context5.sent;
                data = _yield$this$rawReques.data;
                return _context5.abrupt("return", data);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function request(_x4) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "requestRootResource",
    value: function requestRootResource() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.requestResource(undefined, options);
    }
  }, {
    key: "AppVersion",
    set: function set(value) {
      this._appVersion = value;
    }
  }, {
    key: "AppFeatures",
    set: function set(value) {
      this._appFeatures = value;
    }
  }, {
    key: "core",
    get: function get() {
      return this._coreInstance;
    },
    set: function set(coreInstance) {
      this._coreInstance = coreInstance;
    }
  }]);
  return BaseService;
}();

exports["default"] = BaseService;
var URL_INTERPOLATION_RULES = /{([\s\S]+?)}/g;